export default __webpack_public_path__ + "static/media/shape-needle-like.e3e3532f.PNG";